import DATA_INTRO_AI3S from "./Introduction/301DataIntroAI3S";
import DATA_BENEFITS_AI3S_1 from "./Introduction/302DataBenefitsAI3S_1";
import DATA_BENEFITS_AI3S_2 from "./Introduction/303DataBenefitsAI3S_2";
import DATA_BENEFITS_AI3S_3 from "./Introduction/304DataBenefitsAI3S_3";
import DATA_CHARACTERS_AI3S from "./Introduction/305DataCharactersAI3S_4";
import DATA_AI3S_DEMO_END from "./AI3S/311DataAI3SDemo_End";
import { DATA_AI3S_DEMO_1 } from "./AI3S/306DataAI3SDemo_1";
import { DATA_AI3S_DEMO_2 } from "./AI3S/307DataAI3SDemo_2";
import { DATA_AI3S_DEMO_3 } from "./AI3S/308DataAI3SDemo_3";
import { DATA_AI3S_DEMO_4 } from "./AI3S/309DataAI3SDemo_4";
import { DATA_AI3S_DEMO_5 } from "./AI3S/310DataAI3SDemo_5";

const AI3S_WORKFLOW = [
  { page: 301, type: "intro-template" as TemplateType, data: DATA_INTRO_AI3S },
  {
    page: 302,
    type: "benefits-template" as TemplateType,
    data: DATA_BENEFITS_AI3S_1,
  },
  {
    page: 303,
    type: "benefits-template" as TemplateType,
    data: DATA_BENEFITS_AI3S_2,
  },
  {
    page: 304,
    type: "benefits-template" as TemplateType,
    data: DATA_BENEFITS_AI3S_3,
  },
  {
    page: 305,
    type: "characters-template" as TemplateType,
    data: DATA_CHARACTERS_AI3S,
  },
  {
    page: 306,
    type: "journey-two-template" as TemplateType,
    data: DATA_AI3S_DEMO_1,
  },
  {
    page: 307,
    type: "journey-two-template" as TemplateType,
    data: DATA_AI3S_DEMO_2,
  },
  {
    page: 308,
    type: "journey-two-template" as TemplateType,
    data: DATA_AI3S_DEMO_3,
  },
  {
    page: 309,
    type: "journey-two-template" as TemplateType,
    data: DATA_AI3S_DEMO_4,
  },
  {
    page: 310,
    type: "journey-two-template" as TemplateType,
    data: DATA_AI3S_DEMO_5,
  },
  { page: 311, type: "end-template" as TemplateType, data: DATA_AI3S_DEMO_END },
];

export default AI3S_WORKFLOW;
